import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=27f1fa46&scoped=true&"
import script from "./ContentWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContentWrapper.vue?vue&type=style&index=0&id=27f1fa46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1fa46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
